import styled from "styled-components";
import { primaryColor } from "../styled/Theme";
import { APP_NAME } from "../../utils/constants";
import {
  Children,
  cloneElement,
  Fragment,
  isValidElement,
  useState,
} from "react";
import { IconButton } from "@mui/material";
import { EyeOffOutline, EyeOutline } from "@raresail/react-ionicons";

export const LogoText = () => {
  return (
    <p className="extraBold" style={{ fontSize: 28, marginBottom: 0 }}>
      <span className="mainColor">{APP_NAME}</span>
    </p>
  );
};

export const PasswordWrapper = ({ children }: any) => {
  const [show, setShow] = useState(false);
  const togglePassword = () => setShow(!show);
  const type = show ? "text" : "password";
  const Icon = show ? EyeOutline : EyeOffOutline;

  const component = cloneElement(children, { type });

  return (
    <div style={{ position: "relative" }}>
      <div style={{ position: "absolute", right: 5, top: 4 }}>
        <IconButton size="small" onClick={togglePassword}>
          <Icon fontSize={18} />
        </IconButton>
      </div>

      {component}
    </div>
  );
};

export const InputIconWrapper = ({ children, icon, showIcon = true }: any) => {
  const component = cloneElement(children);

  return (
    <div style={{ position: "relative" }}>
      {showIcon && (
        <div style={{ position: "absolute", right: 5, top: 4 }}>{icon}</div>
      )}
      {component}
    </div>
  );
};

export const ItemWrapper = styled.div`
  padding: 6px 10px;
  min-height: 32px;
  font-size: 12px;
  border-radius: 5px;
  transition: 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  color: black;

  &:hover {
    background-color: #f2f2f2;
    color: ${primaryColor};
  }
`;

export const EmptyWrapper = styled.span`
  font-size: 12px;
  font-style: italic;
  color: #cccccc;
`;

export const AnimateChildren = ({
  children,
  startIndex = 0,
}: {
  children: any;
  startIndex?: number;
}) => {
  return Children.map(children, (child, i) => {
    if (!child) return null;

    // If child is a Fragment, spread its children instead
    if (isValidElement(child) && child.type === Fragment) {
      return (
        <AnimateChildren startIndex={i}>
          {(child as any).props.children}
        </AnimateChildren>
      );
    }

    const index = i + startIndex;

    return (
      <div
        key={index}
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-offset={index * -10}
        data-aos-delay={index * 100}
      >
        {child}
      </div>
    );
  });
};
